<template>
  <div class="plans">
    <div class="top-action">
      <div class="top-title">
        <div>我的缴费</div>
        <div v-if="userInfo.eduCode == 205" style="color: #409eff; cursor: pointer" @click="gotoPayProcess">
          缴费流程
        </div>
      </div>
    </div>
    <a-spin :spinning="applySpinning">
      <div class="content">
        <!-- <div class="payTop">
          <div class="payTop-left">平台费：</div>
          <div class="payTop-right">
            <strong
              class="margin-right-20"
              :class="userInfo.feeFlag ? 'text-green' : 'text-red'"
              ><span v-show="userInfo.feeFlag">已缴费</span>
              <span v-show="!userInfo.feeFlag">未缴费</span></strong
            >
          </div>
        </div>
        <div class="bottom-title">学费：</div> -->
        <table class="table">
          <tr>
            <th>序号</th>
            <!-- <th>年级</th>
            <th>专业名称</th> -->
            <th>姓名</th>
            <th>学号</th>
            <th>收费区间</th>
            <th>收费项目</th>
            <th>收费金额</th>
            <th>减免金额</th>
            <th>退费金额</th>
            <!-- <th>操作</th> -->
          </tr>
          <tr v-for="(item, index) in arr" :key="index">
            <td>{{ index + 1 }}</td>
            <!-- <td>{{ item.grade }}</td>
            <td>{{ item.proName }}</td> -->
            <td>{{ item.name }}</td>
            <td>
              {{ item.studentNo }}
            </td>
            <td>
              {{ item.year }}
            </td>
            <td>
              {{ item.projectName }}
            </td>
            <td>
              {{ item.money1 }}
            </td>
            <td>
              {{ item.money2 }}
            </td>
            <td>
              {{ item.money3 }}
            </td>

            <!-- <td>
              <div v-if="item.status == 0">
                <button
                  class="btn"
                  style="width: 60px; margin-left: 30px"
                  @click="gotoPay(item)"
                >
                  缴费
                </button>
              </div>
            </td> -->
          </tr>
        </table>
        <!-- <div class="pagination">
          <a-pagination show-quick-jumper :default-current="1" :total="total" :current="pageNo" :pageSize="pageSize" @change="onChange" />
        </div> -->
      </div>
    </a-spin>
    <!-- 缴费弹窗 -->
    <!-- <a-modal
      title="收银台"
      :visible="visiblePay"
      @cancel="handlePayCancel"
      width="600px"
      :bodyStyle="{ paddingBottom: 0 }"
      destroyOnClose
    >
      <div class="order-num">应收金额：<span>￥1800</span></div>
      <div v-if="qrcodeVisible" class="qrcode">
        <img src="@/assets/images/QRCode.png" alt="" />
        <div class="margin-top-10">
          请使用{{ payType == 1 ? "支付宝" : "微信" }}扫码支付
        </div>
      </div>
      <div class="orderDetail">
        <div class="order-item">
          <strong>订单编号：</strong>1866396362445049858
        </div>
        <div class="order-item"><strong>收款项目：</strong>学费</div>
        <div class="order-item"><strong>订单描述：</strong>测试学生101201</div>
      </div>
      <div v-if="!qrcodeVisible" class="payTypeTxt">请选择支付方式：</div>
      <div v-if="!qrcodeVisible" class="payType">
        <a-radio-group v-model="payType">
          <a-radio :style="radioStyle" :value="1"
            ><a-icon
              type="alipay-circle"
              style="color: #40a9ff"
            />支付宝</a-radio
          >
          <a-radio :style="radioStyle" :value="2"
            ><a-icon type="wechat" style="color: #24b52d" />微信</a-radio
          >
        </a-radio-group>
      </div>
      <template slot="footer">
        <div v-if="!qrcodeVisible" class="exchange-footer">
          <a-button type="primary" class="sure-btn" @click="onSurePay"
            >确认付款</a-button
          >
        </div>
        <div v-if="qrcodeVisible"></div>
      </template>
    </a-modal> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ApplyList",
  data: function () {
    return {
      arr: [],
      applySpinning: false,
      visiblePay: false,
      qrcodeVisible: false,
      payType: 1,
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      // pageNo: 1,
      // pageSize: 10,
      // total: 0,
      statusList: ["未缴费", "已缴费"], // 0未缴费   1已缴费
      colorList: ["#ff0000", "#212529"], // 待审核  通过  失败   已取消
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    getList() {
      const params = {
        studentNo: this.userInfo.studentNo,
        eduCode: this.userInfo.eduCode,
      };
      this.applySpinning = true;
      this.axios
        .get(`/stuFee/queryStuFeeList`, {
          params,
        })
        .then((res) => {
          if (res.success) {
            this.arr = res.result;
          }
        })
        .finally(() => {
          this.applySpinning = false;
        });
    },

    gotoPay() {
      this.visiblePay = true;
    },

    handlePayCancel() {
      this.visiblePay = false;
      this.qrcodeVisible = false;
      this.payType = 1;
    },

    onSurePay() {
      this.qrcodeVisible = true;
    },

    gotoPayProcess() {
      const url = `https://www2.ncwu.edu.cn/jixujiaoyu/info/1055/1929.htm`;
      window.open(url);
    },

    // onChange(index) {
    //   this.pageNo = index;
    //   this.getList();
    // },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.plans {
  min-height: calc(100vh - 584px);

  .content {
    background: #fff;
    padding: 28px;
    .pagination {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 30px 0;
    }

    .result {
      background: #f8faf9;
      padding: 20px;
      margin-bottom: 30px;
      margin-top: 10px;
      color: #999999;
      width: 100%;

      strong {
        font-weight: bold;
        margin-right: 20px;
        color: #333;
      }
    }
  }

  .btn {
    width: 80px;
    height: 26px;
    line-height: 26px;
    padding: 0;
    background: #2caf7a;
    text-align: center;
    color: #fff;
    border: none;
    border-radius: 4px;
  }

  .active {
    background: $bgColor;
  }

  th {
    text-align: center;
    background: #f6f6f8;
    padding: 12px 0;
    border: 1px solid #fff;
  }

  td {
    text-align: center;
    vertical-align: middle;
    padding: 12px 0;
    border: 1px solid #fff;
  }

  tr:nth-child(odd) {
    background: #f6f6f8;
  }
}
.top-action {
    .top-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom:30px;
        display: flex;
        justify-content: space-between;
        a {
          color: #DFEFFF;
        }
    }
}
.order-num {
  text-align: center;
  font-size: 18px;
  margin: 10px 0;
  span {
    font-size: 20px;
    font-weight: bold;
    color: #ff0000;
  }
}
.orderDetail {
  background: #f2f7f9;
  padding: 20px;
  margin-bottom: 20px;

  .order-item {
    margin-bottom: 5px;
   strong {
    font-weight: bold;
   }
  }
}
.payTypeTxt {
  font-size: 15px;
  font-weight: bold;
}
.payType {
  margin: 10px 0;
  padding-bottom: 10px;
  .anticon {
    vertical-align: 0;
    margin-right: 2px;
  }
  .left {
    height: 40px;
    display: flex;
    vertical-align: middle;
  }
}
.qrcode {
  text-align: center;
  margin: 10px 0;
}
.payTop {
  display: flex;
  margin-bottom: 16px;
  .payTop-left {
    font-size: 16px;
    font-weight: bold;
  }
  .payTop-right {
    strong {
      color: #333;
    }

    .text-red {
      color: #ff0000;
    }

    .text-green {
      color: #20d436;
    }
  }
}
.bottom-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/tuitionPayment/components/ApplyList.vue